import { createSlice } from "@reduxjs/toolkit";

const reduxMun = createSlice({
    name: 'redux_mun',//변경해도 의미 없네 (내부적으로 식별 용도인 듯)
    initialState: {
        munList: [],
        cartListAll: [],
        cartList: [],
        removeCartList: [],
        isCartNew: false,//사용 안함
        updateCartListRemove: [],
        isShowNextMun: false,
        isRemoveCart: false,
        isRemoveCartAll: false,
        isModal_mun: false,
        isModal_saveTest: false,
        isHidden_saveTest: false,
        isLoad_saveTest: false,
        isLoad_Mun: false,
        isRemake: false,
        testCodeMunObj: {},
        isTakeExam: false,
        // selectedClassList: {},
        // isAdmin: false,
        // isLoggedIn: false,
        // isSubmenuVisible: false,
        // userInfo:{},
    },
    
    reducers: {

        setMunList: (state, action) => {
            state.munList = action.payload;
        },
        setCartListAll: (state, action) => {
            state.cartListAll = action.payload;
        },

        setCartList: (state, action) => {
            state.cartList = action.payload;
        },

        setIsCartNew: (state, action) => {
            state.isCartNew = action.payload;
        },

        setRemoveCartList: (state, action) => {
            state.removeCartList = action.payload;
        },

        setUpdateCartListRemove: (state, action) => {
            state.updateCartListRemove = action.payload;
        },

        setIsShowNextMun: (state, action) => {
            state.isShowNextMun = action.payload;
        },

        setIsRemoveCart: (state, action) => {
            state.isRemoveCart = action.payload;
        },
        setIsRemoveCartAll: (state, action) => {
            state.isRemoveCartAll = action.payload;
        },


        setIsModal_mun: (state, action) => {
            state.isModal_mun = action.payload;
        },
        setIsModal_saveTest: (state, action) => {
            state.isModal_saveTest = action.payload;
        },
        setIsHidden_saveTest: (state, action) => {
            state.isHidden_saveTest = action.payload;
        },
        setIsLoad_saveTest: (state, action) => {
            state.isLoad_saveTest = action.payload;
        },
        setIsLoadMun: (state, action) => {
            state.isLoad_Mun = action.payload;
        },
        setIsRemake: (state, action) => {
            state.isRemake = action.payload;
        },
        setTestCodeMunObj: (state, action) => {
            state.testCodeMunObj = action.payload;
        },
        setIsTakeExam: (state, action) => {//응시
            state.isTakeExam = action.payload;
        },
        
        
        
        // setSelectedClassList: (state, action) => {
        //     state.selectedClassList = action.payload;
        // },
        // setIsAdmin: (state, action) => {
        //     state.isAdmin = action.payload;
        // },
        // setIsLoggedIn: (state, action) => {
        //     state.isLoggedIn = action.payload;
        // },
        // setIsSubmenuVisible: (state, action) => {
        //     state.isSubmenuVisible = action.payload;
        // },

        // setUserInfo: (state, action) => {
        //     state.userInfo = action.payload;
        // },

    }


});



export const { 
    setMunList, setCartList, setRemoveCartList, setUpdateCartListRemove,
    setIsShowNextMun, setIsRemoveCart, setIsRemoveCartAll,
    setIsModal_mun, setIsModal_saveTest, setCartListAll, 
    setIsHidden_saveTest, setIsLoad_saveTest, setIsLoadMun,
    setIsRemake, setTestCodeMunObj, setIsTakeExam,
    // setSelectedClassList,
    // setIsAdmin,
    // setIsLoggedIn,
    // setIsSubmenuVisible,
    // setUserInfo,
} = reduxMun.actions;

export default reduxMun.reducer;

